// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1785854203821
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/loader.scss
// module id = ./src/components/Loader/loader.scss
// module chunks = 0